class EivykVariantPanels extends HTMLElement {
  connectedCallback() {
    this.showVariant(this.dataset.initialVariantId);
    this.bindVariantChanges();
  }

  bindVariantChanges(attempt = 0) {
    const pubsub = window.FoxTheme?.pubsub;
    const eventName = pubsub?.PUB_SUB_EVENTS?.variantChange;

    if (pubsub?.subscribe && eventName) {
      this.unsubscribe = pubsub.subscribe(eventName, ({ data } = {}) => {
        if (data?.variant?.id) this.showVariant(data.variant.id);
      });
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => this.bindVariantChanges(attempt + 1), 100);
    }
  }

  showVariant(id) {
    if (!id) return;
    const selector = this.dataset.panelSelector;
    if (!selector) return;
    this.querySelectorAll(selector).forEach((panel) => {
      panel.hidden = panel.dataset.variantId !== String(id);
    });
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
  }
}

class EivykProductHighlights extends EivykVariantPanels {}
class EivykProductUrgency extends EivykVariantPanels {}

if (!customElements.get('eivyk-product-highlights')) {
  customElements.define('eivyk-product-highlights', EivykProductHighlights);
}
if (!customElements.get('eivyk-product-urgency')) {
  customElements.define('eivyk-product-urgency', EivykProductUrgency);
}